export class StepGuideV2SetupMode {
  constructor (onboarding) {
    this.onboarding = onboarding;
  }

  id = "guide_v2_setup_mode";
  title = "Enable Device";

  template = `
  <div class="onboarding-step" data-for="guide_v2_setup_mode">
    
    <div class="onboarding-guide">
      <p class="onboarding-guide-instruction">
        Power on your device and wait for the LED to blink red indicating you're in setup mode.
      </p>
      
      <img data-for="v2-server-mode" class="onboarding-guide-instruction-image" src="${window.site.home}/../assets/images/setup/v2_server_mode_red_led.gif" width="292" height="400" />
      
      <p class="onboarding-guide-instruction">
        If you have a steady blinking <b>red</b> light, click on "next" below to proceed.
      </p>
      
      <div class="onboarding-guide-next">
        <button class="button onboarding-guide-next-btn" data-for="guide_v2_setup_mode_next">
          Next
        </button>
      </div>
      
      <div class="onboarding-guide-help">
        <button class="button button--link onboarding-guide-help-btn" data-for="guide_v2_setup_mode_help">
          Help! It's Not Blinking Red
        </button>
      </div>
      
    </div>
   
    
  </div>
  `;

  onBack = () => {
    this.onboarding.goToStep("guide_select_model");
    this.onboarding.hideBackButton();
  }

  onActivate = () => {
    this.onboarding.sensor_version = 'v2';
    this.onboarding.showBackButton();
  }

  bindActions = () => {

    this.$nextBtn = $(this.onboarding.container).find('button[data-for="guide_v2_setup_mode_next"]');
    this.$nextBtn.on('click', () => {
      this.onboarding.goToStep("step_setup_wifi_password");
    });

    this.$helpBtn = $(this.onboarding.container).find('button[data-for="guide_v2_setup_mode_help"]');
    this.$helpBtn.on('click', () => {
      this.onboarding.goToStep("guide_v2_setup_help");
    });

  }

}
